import type React from "react";
import { ReactComponent as Svg } from "./assets/quaddies-logo.svg";
import * as styles from "./Icon.module.scss";

type QuaddiesProps = React.SVGProps<SVGSVGElement>;

export const Quaddies = ({ className, ...props }: QuaddiesProps) => (
  <Svg className={className ?? styles.base} {...props} />
);
